<template>
  <div class="importStaffStepTwo">
    <div class="breadcrumb-area pos-relative">
      <h1>Tải danh sách nhân viên</h1>
    </div>
    <!-- End Breadcrumb Area -->

    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body">
        <div class="step-content">
          <div class="step-upfile">
            <section class="open-input">
              <div class="oi-alert">
                <span style="width: 80px; display: inline-block"
                  ><img src="@/assets/img/upload-thanhcong.svg" alt=""
                /></span>
              </div>
            </section>
            <p>Số lượng bản ghi tải lên thành công: {{ dataImport.length }}</p>
          </div>
          <div class="step-upfooter m-t-0">
            <ul>
              <li>
                <router-link class="btn btn-primary" :to="`/staff-import-step-one`"
                  >Nhập file mới</router-link
                >
              </li>
              <li>
                <router-link class="btn btn-outline-secondary" :to="`/staff`"
                  >Danh sách nhân viên</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    computed: {
      ...mapGetters({
        dataImport: 'staff/getDataCacheTableRow',
      }),
    },
  }
</script>

<style scoped></style>
